enum PublicPolicyViewSectionName {
	LANDING = 'Landing',
	MORTGAGEE = 'Mortgagee',
	ADD_MORTGAGEE = 'AddMortgagee',
	BACK_TO_PRELIMINARY = 'BackToPreliminary',
}

namespace PublicPolicyViewSectionName {
	export function toEnumList(): PublicPolicyViewSectionName[] {
		let publicPolicyViewSectionNames: PublicPolicyViewSectionName[] = Object.keys(PublicPolicyViewSectionName)
			.filter((key: string) => key !== PublicPolicyViewSectionName.toEnumList.name)
			.map((key: string) => PublicPolicyViewSectionName[key]);
		return publicPolicyViewSectionNames;
	}
}

export default PublicPolicyViewSectionName;